import type { UseQueryResult } from "@tanstack/react-query/src/types.ts";
import type { ResponseConfig } from "../client.ts";
import type { GetDataWrapperResult } from "../components/MutateWrapper.tsx";

export function useGetDataNew<TData>(
  useQuery: () => UseQueryResult<ResponseConfig<TData> | undefined, any>,
): GetDataWrapperResult<TData> {
  const result = useQuery();
  return {
    loading: result.isLoading,
    data: result?.data?.data,
    error: result.error,
    refresh: result.refetch,
  };
}

export default useGetDataNew;
